/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment";
import Table from "../../../components/common/new/Table/Table";
import { PERMISSIONS_SEAECH_TABLE_COL } from "../../../contants/table/memberSearch";
import tableStyle from "../../../theme/styles/table";
import styles from "../MemberRoleTable/style";
import Typography from "../../../components/common/new/Typography/Typography";
import Eye from "../../../assets/svg/Eye";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
    textAlign: "center",
  },
  small: {
    maxWidth: "6rem",
    textAlign: "center",
  },
  medium: {
    maxWidth: "10rem",
    textAlign: "center",
  },
};

const getRows = ({ searchData, onView }) =>
  searchData.map((roleInfo) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={tabelCellWidth.small}>
        <Typography style={styles.typoghrphyStyle}>{roleInfo.name}</Typography>{" "}
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <div style={styles.tableBox}>
          <Typography style={styles.typoghrphyStyle}>
            {roleInfo?.updatedBy || "-"}
          </Typography>
        </div>
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <div style={styles.tableBox}>
          <Typography>
            {roleInfo?.updatedAt !== null
              ? moment(roleInfo?.updatedAt).format("L")
              : "-"}
          </Typography>
        </div>
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        {" "}
        <div
          style={{
            ...styles.actionButtons,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Eye
            style={{
              ...styles.actionIcon,
              marginTop: "4px",
            }}
            onClick={() => onView(roleInfo)}
          />
        </div>
      </TableCell>
    </TableRow>
  ));

function ManagePermissionTable({
  searchData,
  onView,
  hasPermission,
  showStatusColumn,
}) {
  const columns = showStatusColumn
    ? PERMISSIONS_SEAECH_TABLE_COL
    : PERMISSIONS_SEAECH_TABLE_COL.filter((c) => c.key !== "status");

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onView,
          hasPermission,
          showStatusColumn,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ManagePermissionTable;
